/* ==========================================================================
   esimReise · Produktseite „Variante A“ · 30.08.2026
   Vier Aufgaben:
     1) Vorteile + Netz-Karte unter das grosse Bild (Desktop) bzw. ans Ende
        der Infospalte (Handy) bringen.
     2) Preis und Kaufbutton in einen grauen Kasten fassen und darunter
        „für 3 GB · 30 Tage · 2,33 € / GB“ schreiben.
     3) Den Roaming-Vergleich auf das gewaehlte Paket umrechnen.
     4) Vergleich und 30-Sekunden-Test unter die Texte der linken
        Spalte schieben.
   Alles laeuft ueber einen delegierten change-Listener und ist mehrfach
   aufrufbar: Dawn rendert beim Variantenwechsel Teile der Seite neu.
   ========================================================================== */
(function () {
  /* Die Datei wird an zwei Stellen eingebunden (linke Spalte und, bei
     Zielen ausserhalb der EU, im Paket-Picker). Zweimal ausfuehren waere
     unnoetig – der zweite Durchlauf steigt hier aus. */
  if (window.__esrPdpA) return;
  window.__esrPdpA = true;

  var HINT = 'Im Warenkorb bestätigst du kurz drei Punkte – danach kannst du bezahlen.';

  function one(sel, root) { return (root || document).querySelector(sel); }
  function all(sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); }

  /* Mehrfach vorhandene Elemente aufraeumen, das letzte bleibt uebrig. */
  function dedupe(sel) {
    var list = all(sel);
    for (var i = 0; i < list.length - 1; i++) {
      if (list[i].parentNode) list[i].parentNode.removeChild(list[i]);
    }
    return list.length ? list[list.length - 1] : null;
  }

  function money(box, cents) {
    var fmt = box.getAttribute('data-money-fmt') || '1,00 €';
    return fmt.replace('1,00', (cents / 100).toFixed(2).replace('.', ','));
  }

  /* ---------- 1) Vorteile, Netz-Karte und 30-Sekunden-Test ------------ */
  function leftColumn() {
    var src = one('.product__info-container > .esr-pdp__left');
    if (!src) return;
    var media = one('.product__media-wrapper');
    var big = window.matchMedia('(min-width: 990px)').matches;
    var copy = media ? one('.esr-pdp__left', media) : null;
    var test = one('.esr-pdp__box');

    if (big) {
      if (media && !copy) media.appendChild(src.cloneNode(true));
      /* Der 30-Sekunden-Test steht als Letztes in der linken Spalte.
         Den Roaming-Vergleich schiebt roaming() davor. */
      if (media && test && test.parentNode !== media) media.appendChild(test);
    } else {
      if (copy && copy.parentNode) copy.parentNode.removeChild(copy);
      /* Handy: der Test wandert zurueck in die Infospalte, hinter den
         Vergleich – also genau dorthin, wo er im Template steht. */
      var back = one('.product__info-container > [data-esr-roam]') || one('.esr-pdp__hint');
      if (test && back && back.parentNode && test.previousElementSibling !== back) {
        back.parentNode.insertBefore(test, back.nextSibling);
      }
      /* Auf dem Handy steht der Block am Ende, direkt vor dem
         Zahlungshinweis – so wie in der Vorlage. */
      var pay = one('.esr-pdp__pay');
      if (pay && pay.parentNode && src.nextElementSibling !== pay) {
        pay.parentNode.insertBefore(src, pay);
      }
    }
  }

  /* ---------- 2) Preiszeile + Hinweis ---------------------------------
     WICHTIG: hier wird NICHTS umgebaut und NICHTS verschoben. Zwei frueher
     Versuche sind daran gescheitert: ein <div> um Preis und Kaufbutton
     brachte Dawn dazu, beim Umschalten eine zweite Paketliste anzulegen,
     und ein Aufraeumen dieser Liste loeschte sie ganz. Eingefuegt werden
     nur zwei eigene <p> als Nachbarn. Der graue Kaufkasten entsteht rein
     ueber CSS aus den nebeneinanderliegenden Elementen (siehe
     snippets/esr-pdp-left.liquid).                                        */
  function buyBox() {
    var info = one('.product__info-container');
    var form = one('.product-form');
    if (!info || !form) return;
    var price = one('[id^="price-"]', info) || one('.price', info);
    if (!price) return;
    /* Falls der Preis in einem Wrapper steckt: den Wrapper als Anker nehmen. */
    while (price.parentNode && price.parentNode !== info) price = price.parentNode;

    var after = price;
    var tax = one('.product__tax', info);
    if (tax && tax.parentNode === info) after = tax;

    var line = dedupe('.esr-pdp__forline');
    if (!line) {
      line = document.createElement('p');
      line.className = 'esr-pdp__forline';
    }
    if (after.nextElementSibling !== line) {
      info.insertBefore(line, after.nextSibling);
    }

    var hint = dedupe('.esr-pdp__hint');
    if (!hint) {
      hint = document.createElement('p');
      hint.className = 'esr-pdp__hint';
      hint.textContent = HINT;
    }
    var formTop = form;
    while (formTop.parentNode && formTop.parentNode !== info) formTop = formTop.parentNode;
    if (formTop.nextElementSibling !== hint) {
      info.insertBefore(hint, formTop.nextSibling);
    }

    /* Alles zwischen der „für …"-Zeile und dem Hinweis bekommt die Klasse
       esr-buyrow. Der Kaufbutton steckt in einem Zwischen-<div>, sonst
       reisst der graue Hintergrund genau dort auf. */
    var n = line.nextElementSibling;
    while (n && n !== hint) { n.classList.add('esr-buyrow'); n = n.nextElementSibling; }

    /* „für 3 GB · 30 Tage · 2,33 € / GB“ – direkt aus der gewaehlten Zeile
       gelesen, damit hier keine zweite Preisquelle entsteht. */
    var checked = one('.esr-plans input[type="radio"]:checked');
    var label = checked ? checked.nextElementSibling : null;
    if (label && label.classList.contains('esr-plan')) {
      var vol = one('.esr-plan__vol', label);
      var days = one('.esr-plan__days', label);
      var ppg = one('.esr-plan__ppg', label);
      var parts = [];
      if (vol) parts.push(vol.textContent.trim());
      if (days) parts.push(days.textContent.replace('gültig', '').trim());
      if (ppg) parts.push(ppg.textContent.trim());
      line.textContent = parts.length ? 'für ' + parts.join(' · ') : '';
    }
  }

  /* ---------- 3) + 4) Roaming-Vergleich -------------------------------- */
  function roaming() {
    var box = dedupe('[data-esr-roam]');
    if (!box) return;

    /* Desktop: der Vergleich steht unter den Texten der linken Spalte,
       direkt unter der Vorteilsliste. Handy: unter dem Kaufkasten. */
    var media = one('.product__media-wrapper');
    var big = window.matchMedia('(min-width: 990px)').matches;
    var anchor = big && media ? one('.esr-pdp__left', media) : null;
    if (!anchor) anchor = one('.esr-pdp__hint') || one('.product-form');
    if (anchor && anchor.parentNode &&
        (box.previousElementSibling !== anchor || box.parentNode !== anchor.parentNode)) {
      anchor.parentNode.insertBefore(box, anchor.nextSibling);
    }

    var raw = one('[data-esr-roam-data]', box);
    if (!raw) return;
    var data;
    try { data = JSON.parse(raw.textContent); } catch (e) { return; }
    if (!data || !data.plans || !data.plans.length) return;

    var checked = one('.esr-plans input[type="radio"]:checked');
    var name = checked ? checked.value : null;
    var plan = null;
    for (var i = 0; i < data.plans.length; i++) {
      if (!name || data.plans[i].v === name) { plan = data.plans[i]; break; }
    }
    if (!plan) plan = data.plans[0];

    /* Reisedauer: die Laufzeit des Pakets, aber hoechstens zwei Wochen.
       Laenger reist kaum jemand am Stueck – eine groessere Zahl waere
       geschoent und damit angreifbar. */
    var trip = Math.min(plan.d, 14);
    var total = data.day * trip;
    var max = Math.max(total, plan.p);

    function set(sel, txt) { var n = one(sel, box); if (n) n.textContent = txt; }
    set('[data-roam-days]', trip + ' Tage');
    set('[data-roam-total]', money(box, total));
    set('[data-roam-price]', money(box, plan.p));
    set('[data-roam-plan]', plan.v);

    var own = one('[data-roam-own]', box);
    if (own) own.style.width = Math.max(3, (plan.p / max) * 100) + '%';
  }

  function run() {
    try {
      dedupe('.esr-pdp__pills');
      /* variant-selects NICHT aufraeumen: das verwaltet Dawn selbst.
         Ein Versuch, dort doppelte Elemente zu entfernen, hat beim
         Umschalten die ganze Paketliste geloescht. */
      leftColumn();
      buyBox();
      roaming();
    } catch (e) {}
  }

  /* Dawn holt die neue Variante per fetch: der Umbau der Seite passiert
     ERST ein paar hundert Millisekunden nach dem Klick. Deshalb sofort
     und zweimal verzoegert aufraeumen – sonst bleibt der Roaming-Kasten
     doppelt stehen. */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('.esr-plans input[type="radio"]')) {
      run();
      setTimeout(run, 400);
      setTimeout(run, 1200);
    }
  });
  window.addEventListener('resize', run);
  run();
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  setTimeout(run, 300);
  setTimeout(run, 1500);
})();
